import get from 'lodash.get';

import { emptyArray } from '../../default-props/empty';

export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectFulfillmentPlanIds = (state) => get(state, 'fulfillmentPlanIds', emptyArray);
